import React, { useEffect } from "react";
import { Input } from "antd";
import styles from "./App.module.less";

const { Search } = Input;
const PassWordText = "2580";

const Password = (props: any) => {
  const { setLock } = props || {};

  const handleSearch = (word) => {
    if (word === PassWordText) {
      setLock(false);
    } else {
      window.location.href = `https://m.baidu.com/s?word=${word}`;
    }
  };

  useEffect(() => {
    if (process.env.NODE_ENV !== "development") {
      window.addEventListener("blur", function () {
        setLock(true);
      });
    }

    document.addEventListener("visibilitychange", () => {
      if (document.visibilityState === "hidden") {
        setLock(true);
      }
    });

    window.addEventListener("pagehide", () => {
      setLock(true);
    });
  }, []);

  return (
    <div className={styles.pwdWrp}>
      <div className={styles.logoWrp}>
        <img className={styles.logo} src="/images/logo.png" />
      </div>

      <Search
        allowClear
        size="large"
        enterButton="百度一下"
        onSearch={handleSearch}
        placeholder="输入搜索词"
      />
    </div>
  );
};

export default Password;
